// utils/pdfCoordinatesAnnullamento.ts

// Questi sono valori di esempio. DOVRAI MISURARE E INSERIRE LE COORDINATE REALI
// Per determinare le coordinate:
// 1. Apri 'modelloann.pdf' in un editor PDF (es. Adobe Acrobat Reader, Foxit Reader, anche un browser).
// 2. Utilizza la funzione di "misura" o gli strumenti di ispezione per trovare le coordinate X e Y esatte
//    (spesso partendo dal basso a sinistra) dove vuoi posizionare il testo.

export const COORDS_ANNULLAMENTO = {
  agenziaData: { x: 536, y: 735 },  // Esempio: Posizione per "NOME AGENZIA"
  targa:       { x: 382,  y: 556 },
  data_eliminazione: { x: 237, y: 542 }, // Nuovo campo: Data Eliminazione
  nominativo:  { x: 222,  y: 621 },
  cf_piva:     { x: 176,  y: 602 },
  // Aggiungi altre coordinate se necessario per altri campi.
};

// Puoi anche definire altri parametri se il layout lo richiede
export const FONT_SIZE_ANNULLAMENTO = 10;
export const FIXED_SPACING_ANNULLAMENTO = 5;
